import * as React from "react";
import PageOptions from "./page-options";
import PageSubTitle from "./page-subtitle";
import PageTitle from "./page-title";

interface Props {
  children?: React.ReactNode;
  title?: string;
  subTitle?: string;
  options?: React.ReactNode;
}

const PageHeader: React.FC<Props> = ({
  children,
  title,
  subTitle,
  options,
}) => {
  return (
    <div className="page-header">
      {title && <PageTitle>{title}</PageTitle>}
      {subTitle && <PageSubTitle>{subTitle}</PageSubTitle>}
      {options && <PageOptions>{options}</PageOptions>}
      {children}
    </div>
  );
};

export default PageHeader;
